module.exports = __webpack_public_path__ + "img/ingeniery.86815f97.jpg";